import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function Minicart() {
  const { totalQuantity } = useSelector((state) => state.cart);

  return (
    <Link
      to="/cart"
      className="minicart__open--btn header__account--btn text-white flex items-center relative group"
      style={{ background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'none' }}
    >
      <div className="relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 14.706 13.534"
          className="svg transition-transform group-hover:scale-110"
        >
          <g transform="translate(0 0)">
            <g>
              <path
                data-name="Path 16787"
                d="M4.738,472.271h7.814a.434.434,0,0,0,.414-.328l1.723-6.316a.466.466,0,0,0-.071-.4.424.424,0,0,0-.344-.179H3.745L3.437,463.6a.435.435,0,0,0-.421-.353H.431a.451.451,0,0,0,0,.9h2.24c.054.257,1.474,6.946,1.555,7.33a1.36,1.36,0,0,0-.779,1.242,1.326,1.326,0,0,0,1.293,1.354h7.812a.452.452,0,0,0,0-.9H4.74a.451.451,0,0,1,0-.9Zm8.966-6.317-1.477,5.414H5.085l-1.149-5.414Z"
                transform="translate(0 -463.248)"
                fill="currentColor"
              />
              <path
                data-name="Path 16788"
                d="M5.5,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,5.5,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,6.793,478.352Z"
                transform="translate(-1.191 -466.622)"
                fill="currentColor"
              />
              <path
                data-name="Path 16789"
                d="M13.273,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,13.273,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,14.566,478.352Z"
                transform="translate(-2.875 -466.622)"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
        <span className="items__count absolute -top-2 -right-2 bg-yellow-400 text-teal-900 font-black flex items-center justify-center w-5 h-5 rounded-full text-[10px] shadow-lg border border-teal-600">
          {totalQuantity}
        </span>
      </div>
    </Link>
  );
}

export default Minicart;
